import { lazy } from "react";

import { importRemote } from "@module-federation/utilities";
import { MicroFrontendLoader } from "@moodys/mdc-frontend.helpers.micro-frontend-loader";
import { getMFEBasePath } from "@moodys/mdc-shared-runtime";

import { LetterformSpinner } from "@moodys/federated";

const ScreenerHome = lazy(() =>
  importRemote({
    url: getMFEBasePath({
      path: "mfe/screener",
      staticStructure: true,
    }),
    scope: "MdcScreener",
    module: "Screener",
    bustRemoteEntryCache: false,
  })
);

export const Screener = () => {
  return (
    <MicroFrontendLoader
      skeleton={<LetterformSpinner />}
      renderOnIntersect={false}
    >
      <ScreenerHome />
    </MicroFrontendLoader>
  );
};
